<template>
  <div>
    <el-row>
      <el-col style="width: 350px" align="left">
        <div class="option-label" style="margin-left: 10px; padding-bottom: 5px; padding-top: 10px">Show</div>
        <el-radio-group v-model="plotOrganism" size="small" style="margin-left: 10px">
          <el-tooltip class="item" content="Plot data for the current organism" effect="dark" placement="top" :enterable="false">
            <el-radio-button label="current">Current Organism</el-radio-button>
          </el-tooltip>
          <el-tooltip class="item" content="Compare data for all selected organisms" effect="dark" placement="top" :enterable="false">
            <el-radio-button label="all">All selected Organisms</el-radio-button>
          </el-tooltip>
        </el-radio-group>
      </el-col>

      <el-col style="width: 250px" align="left">
        <div class="option-label" style="padding-bottom: 5px; padding-top: 10px">Select repeats</div>
        <el-select v-model="plotOptions.selected" collapse-tags multiple filterable
          placeholder="Select repeats" style="width: 90%" size="small">
          <el-option-group v-for="group in repeatsMultiSelectOptions" :key="group.label" :label="group.label">
            <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>
      </el-col>
    
      <el-col style="width: 150px" align="left">
        <div class="option-label" style="padding-bottom: 5px; padding-top: 10px">Bin size (bp)</div>
        <el-input-number v-model="plotOptions.bin" size="small" :step="100" :min="100" step-strictly></el-input-number>
      </el-col>

      <el-col style="width: 120px" align="left">
        <div class="option-label" style="margin-left: 10px; padding-bottom: 5px; padding-top: 10px">Data type</div>
        <el-select v-model="plotOptions.datatype" size="small"
          style="width: 90%; margin-left: 10px; margin-right: 10px">
          <el-option value="density" label="Density"></el-option>
          <el-option value="frequency" label="Frequency"></el-option>
        </el-select>
      </el-col>


    </el-row>


    <el-row v-if="plotOrganism === 'current'" style="margin-top: 20px">
      <modal-unit-area-tss-distribution height="70vh" :series="histDistributionData[store.species.order.indexOf(store.species.current)]"></modal-unit-area-tss-distribution>
    </el-row>

    <el-row :gutter="15" v-if="plotOrganism === 'all'">
      
      <el-row style="padding-bottom: 15px; padding-top: 10px; margin-left: 10px">
        <el-col style="width: 300px" align="left">
          <div class="option-label" style="padding-bottom: 5px; padding-top: 10px; margin-left: 10px">Group by</div>
          <el-switch :disabled="plotOptions.type === 'sort'" style="display: block; margin-left: 10px" v-model="plotOptions.groupByRepeat" inactive-color="#13ce66"
            active-color="#13ce66" active-text="Repeat" inactive-text="Organism"></el-switch>
        </el-col>
      </el-row>
      
      <el-row v-if="!(plotOptions.groupByRepeat)">
        <el-col :lg="8" :md="12" :sm="12" :xs="24"  v-for="(organism, index) in store.info" :key="organism.OrgInfo.MSDBID"
          style="margin-top: 30px">
          <modal-unit-area-tss-distribution :index="index+1" :series="histDistributionData[index]"></modal-unit-area-tss-distribution>
        </el-col>
      </el-row>

      <el-row :gutter="15" v-if="plotOptions.groupByRepeat" >
        <el-col :lg="8" :md="12" :sm="12" :xs="24"  v-for="(repeat, index) in plotOptions.selected" :key="repeat"
          style="margin-top: 30px">
          <modal-unit-area-tss-distribution :index="index+1" :series="histDistributionData[index]"></modal-unit-area-tss-distribution>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
  import { store } from '../scripts/store.js'
  import ModalUnitAreaTssDistribution from '../components/ModalUnitAreaTssDistribution.vue'
  import { repeatsMultiSelectOptions } from '../scripts/repeatsMultiSelectOptions.js'
  import { tssHistData } from '../scripts/utils.js'
  import { repeats } from '../scripts/repeats.js'


  export default {
    name: 'ModalAreaTssDistribution',
    components: {
      ModalUnitAreaTssDistribution
    },
    data() {
      return {
        store: store,
        plotOrganism: "current",
        repeatsMultiSelectOptions: repeatsMultiSelectOptions,
        plotOptions: {
          selected: ["A", "C", "AC", "AG", "AT", "CG"],
          groupByRepeat: false,
          bin: 500,
          datatype: 'density',
        }
      }
    },
    computed: {

      histDistributionData: function(){
        let parameters = this.plotOptions;
        const repeats = parameters.selected;
        const organisms = this.store.species.order;
        let organismNames = [];
        const info = this.store.info;
        const datatype = parameters.datatype;

        let series = [];
        for (let o of organisms) {
            const data = [];
            const orginfo = info.filter(a => { return a.OrgInfo.MSDBID === o; })[0];
            let organismName = orginfo.OrgInfo.OrganismName;
            organismNames.push(organismName);
            const genomeSize = parseInt(orginfo.GenomeInfo.GenomeSize);
            const plotdata = orginfo.AnnoInfo.TSSDist;
            console.log(plotdata)
            const bins = orginfo.AnnoInfo.TSSHistBinEdges;
            const tssData = tssHistData(plotdata, bins, repeats, parameters.bin, datatype);

            for (let rep of repeats) {
                const obj = {};
                obj.name = rep;
                obj.type = 'line';
                obj.data = tssData.data[rep];
                // obj.areaStyle= {};
                obj.showSymbol = false;
                obj.smooth = true;
                data.push(obj);
            }
            if (organismName.length > 25) { organismName = organismName.slice(0, 25) + '...' }
            series.push({title: organismName, data: data})
        }


        if ((parameters.groupByRepeat) && (this.plotOrganism === "all")){
            const tempseries = [];
            repeats.forEach((r, i) => {
                const data = [];
                organisms.forEach((o, j) => {
                    const obj = {};
                    obj.name = organismNames[j];
                    obj.type = 'line';
                    // obj.areaStyle= {};
                    obj.showSymbol = false;
                    obj.smooth = true;
                    obj.data = series[j].data.filter( d => { return d.name === r; })[0].data;
                    data.push(obj);
                })
                tempseries.push({ title: r, data: data })
            })
            series = tempseries
        }
        
        return series;
      }

    }
  }
</script>